export const API_URL = 'https://80ala1muig.execute-api.us-east-1.amazonaws.com/dev/';

export const GOOGLE_CLIENT_IDS = {
  dev: '223233671218-mujcmkmt5plupe2c5piurpvp1h435pgu.apps.googleusercontent.com',
  prod: '223233671218-l6tkqeif7rb8hj35ek87sci396nmt37r.apps.googleusercontent.com'
};